import React, {Fragment} from 'react';
import Navbar2 from '../../components/Navbar2'
import Hero3 from '../../components/hero3'
import Features from '../../components/Features'
import About from '../../components/about'
import Services2 from '../../components/Services2'
import FunFact from '../../components/FunFact'
import Support from '../../components/Support'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import CustomCarousel from '../../components/CarrouselComponent';


const HomePage3 =() => {
    return(
        <Fragment>
            <Navbar2/>
            {/* <Hero3/> */}
            <CustomCarousel />
            <Features featuresClass="wpo-features-section-s2 mt-3"/>
            <About/>
            <Services2 srvClass={'wpo-service-section-s3'}/>
            <FunFact fnClass={'section-padding'}/>
            <Support />
            <Footer className="mt-5"/>
            <Scrollbar/>
        </Fragment>
    )
};
export default HomePage3;